export default __webpack_public_path__ + "images/Payment2.png";